import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Catalogo from "@/pages/Catalogo";
import Importados from "@/pages/Importados";
import Produto from "@/pages/Produto";
import Admin from "@/pages/Admin";
import { SiteProvider, useSite } from "@/context/SiteContext";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (window.__lenis) {
          window.__lenis.scrollTo(el, { offset: -72 });
        } else {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 120);
      return () => clearTimeout(t);
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  useSite();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      <ScrollManager />
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/importados" element={<Importados />} />
          <Route path="/roupas" element={<Navigate to="/importados" replace />} />
          <Route path="/produto/:id" element={<Produto />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && (
        <>
          <Footer />
          <WhatsAppFloat />
        </>
      )}
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-obsidian text-offwhite">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <SiteProvider>
          <Shell />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
